const navbar = document.getElementById("navbar");
const menuButton = document.querySelector("nav button.menu");

if (navbar !== null) {
  window.addEventListener("scroll", (e) => {
    const scrollPos = window.scrollY;
    const width = window.outerWidth;
    const navPos = navbar.getBoundingClientRect().height;
    if (width > 480) {
      if (scrollPos > navPos) {
        navbar.classList.add("sticky");
      } else {
        navbar.classList.remove("sticky");
      }
    }
  });

  menuButton.addEventListener("click", function (event) {
    event.preventDefault();

    const links = document.querySelector("nav div.links");

    if (links.classList.contains("show")) {
      links.classList.remove("show");
    } else {
      links.classList.add("show");
    }
  });
}
